import { DOMOutputSpecArray, MarkSpec } from 'prosemirror-model';

import { RtSchemaType } from '../../../editor/types';
import { MarkName } from '../../../schema/marks';

export class EmMark implements MarkSpec {
  public static readonly markName = MarkName.Em;
  public parseDOM = [{ tag: 'i' }, { tag: 'em' }, { style: 'font-style=italic' }];
  public toDOM(): DOMOutputSpecArray {
    return ['em', 0];
  }
}

export type EmSchema = RtSchemaType<any, typeof EmMark>;
